import { all, takeEvery, put, fork } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import { getToken, clearToken } from '../../helpers/utility';
import actions from './actions';
import auth from '../../helpers/awsAuth';
import { notification } from '../../components';
import { store } from '../store';
import { Auth } from 'aws-amplify';

// export function* loginRequest() {  
//   yield takeEvery('LOGIN_REQUEST', function*(action) {
//     try {
//       const token = yield auth.login(action.payload.email, action.payload.password);     
//       yield put({
//         type: actions.LOGIN_SUCCESS,
//         token: token        
//       });
//     } catch (e) {     
//       yield put({ type: actions.LOGIN_ERROR });
//     }
//   });
// }

// export function* socialLogin() {
//   yield takeEvery('SOCIAL_LOGIN', function*(action) {
//     try {
//       const token = yield auth.handleOauth(action.payload.type, action.payload.authResult);
//       yield put({
//         type: actions.LOGIN_SUCCESS,
//         token: token
//       })
//     } catch (e) {
//       yield put({ type: actions.LOGIN_ERROR});
//     }
//   })
// }

export function* loginSuccess() {
  yield takeEvery(actions.LOGIN_SUCCESS, function* (action) {
    yield auth.setSession(action.token);
  });
}

export function* loginError() {
  yield takeEvery(actions.LOGIN_ERROR, function* () {
    yield notification('error', 'Wrong mail or password');
  });
}

export function* logout() {
  yield takeEvery(actions.LOGOUT, function* () {
    clearToken();
    // yield put(push('/signin'));
  });
}

export function* checkAuthorization() {
  yield takeEvery(actions.CHECK_AUTHORIZATION, function* () {
    try {
      getToken()
        .then(async function (token) {
          token = token.get('idToken');
          if (token) {
            store.dispatch(actions.login(token.jwtToken))
          } else {
            store.dispatch(actions.logout())
            Auth.signOut();
          }
        })
        .catch(function* (e) {
          yield put({
            type: actions.LOGOUT
          });
        })
    } catch (e) {
      yield put({
        type: actions.LOGOUT
      });
    }
  });
}
export default function* rootSaga() {
  yield all([
    fork(checkAuthorization),
    fork(loginError),
    fork(logout),
  ]);
}
